import React from 'react';
import { IconText } from '../IconText/IconText';
import { IconWrapper } from '../IconWrapper/IconWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export const getContent = props => {
  if (props.icon && props.text) {
    return /*#__PURE__*/_jsx(IconText, {
      ...props,
      spaceBetween: 0
    });
  }
  if (props.text) {
    return props.text;
  }
  if (props.icon) {
    return /*#__PURE__*/_jsx(IconWrapper, {
      icon: props.icon,
      color: props.iconColor,
      size: props.iconSize,
      iconIndicator: props.iconIndicator
    });
  }
};